module.exports = "/images/img--bg4.png?6c4c8dbbfb825e701ac87f885cbee18f";